import axios from "./axios";

class PPIDmtService {
  bioDeviceConfig = async () => {
    try {
      const response = await axios.post("/ppi_dmt/bio_device_config", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  feetchConsent = async () => {
    try {
      const response = await axios.post("/ppi_dmt/fetch_consent", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fetchCommercial = async (amount) => {
    try {
      const response = await axios.post("/ppi_dmt/fetch_commercial", {
        amount,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  generateOtp = async (mobile) => {
    try {
      const response = await axios.post("/ppi_dmt/generate_otp", {
        mobile: mobile,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  verifyOtp = async (token, otp) => {
    try {
      const response = await axios.post("/ppi_dmt/verify_otp", {
        token,
        otp,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  biometricKyc = async (
    wallet_token,
    wallet_application_number,
    mobile_number,
    aadhaar_number,
    latitude,
    longitude,
    bio_data
  ) => {
    try {
      const response = await axios.post("/ppi_dmt/kyc/biometric", {
        wallet_token: wallet_token,
        wallet_application_number: wallet_application_number,
        mobile_number: mobile_number,
        aadhaar_number: aadhaar_number,
        latitude: latitude,
        longitude: longitude,
        bio_data: bio_data,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  generateAadhaarOtp = async (
    wallet_token,
    wallet_application_number,
    aadhaar_number
  ) => {
    try {
      const response = await axios.post("/ppi_dmt/generate_aadhaar_otp", {
        wallet_token,
        wallet_application_number,
        aadhaar_number,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  verifyAadhaarOtp = async (
    wallet_token,
    wallet_application_number,
    token,
    otp
  ) => {
    try {
      const response = await axios.post("/ppi_dmt/verify_aadhaar_otp", {
        wallet_token,
        wallet_application_number,
        token,
        otp,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  verifyPAN = async (wallet_token, wallet_application_number, pan_number) => {
    try {
      const response = await axios.post("/ppi_dmt/verify_pan", {
        wallet_token,
        wallet_application_number,
        pan_number,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  beneficiaryList = async (wallet_token, mobile_number) => {
    try {
      const response = await axios.post("/ppi_dmt/beneficiary/list", {
        wallet_token,
        mobile_number,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  addBeneficiary = async (wallet_token, mobile_number, beneficiary) => {
    try {
      const response = await axios.post("/ppi_dmt/beneficiary/add", {
        wallet_token,
        mobile_number,
        beneficiary,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  deleteBeneficiary = async (wallet_token, mobile_number, beneficiary_id) => {
    try {
      const response = await axios.post("/ppi_dmt/beneficiary/delete", {
        wallet_token,
        mobile_number,
        beneficiary_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  validateDeleteBeneficiary = async (
    wallet_token,
    mobile_number,
    token,
    otp
  ) => {
    try {
      const response = await axios.post(
        "/ppi_dmt/beneficiary/validate_delete",
        {
          wallet_token,
          mobile_number,
          token,
          otp,
        }
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fundTransferGenerateOtp = async (
    wallet_token,
    mobile_number,
    name,
    beneficiary_id,
    account_number,
    ifsc_code,
    amount
  ) => {
    try {
      const response = await axios.post("/ppi_dmt/fund_transfer/generate_otp", {
        wallet_token,
        mobile_number,
        name,
        beneficiary_id,
        account_number,
        ifsc_code,
        amount,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fundTransferVerifyOtp = async (
    wallet_token,
    mobile_number,
    name,
    beneficiary_id,
    account_number,
    isfc_code,
    amount,
    token,
    otp
  ) => {
    try {
      const response = await axios.post("/ppi_dmt/fund_transfer/verify_otp", {
        wallet_token,
        mobile_number,
        name,
        beneficiary_id,
        account_number,
        isfc_code,
        amount,
        token,
        otp,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  refundGenerateOtp = async (mobile_number, order_id) => {
    try {
      const response = await axios.post("/ppi_dmt/refund/generate_otp", {
        mobile_number,
        order_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  refundVerifyOtp = async (mobile_number, token, otp) => {
    try {
      const response = await axios.post("/ppi_dmt/refund/verify_otp", {
        mobile_number,
        token,
        otp,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fundTransferHistory = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    refund_pending,
    size,
    page
  ) => {
    try {
      const response = await axios.post("/ppi_dmt/fund_transfer/report", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        refund_pending,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  downloadReceipt = async (order_id) => {
    try {
      const response = await axios.post("/ppi_dmt/download_receipt", {
        order_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new PPIDmtService();
